import ready from 'Util/DOMready';

import 'Modules';
import globals from './globals';

ready(() => {
  globals();
});
